import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { GetProductListViewModelSuccessEnvelop } from '@/types/api'

import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants'

import { getPageNumberFromSearchParams } from '@/components/header/search/utils/search-helpers'

import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines'
import { useUserToken } from '@/app/_utils/session'

import { getProductsList } from './get-products-list'

import { FIRST_LOAD_PAGE_SIZE } from '../constants'
import { usePLPFacetsContext } from '../facets-context/facets-context'
import { PLPReactQueryKeys } from '../types'

export default function usePLPData() {
    const { searchParams } = usePLPFacetsContext()

    const searchParamsPageNumber = getPageNumberFromSearchParams(searchParams)
    const [ut] = useUserToken()

    const requestParams = { ...searchParams }

    if (!searchParamsPageNumber && !PUBLIC_IS_BOT) {
        requestParams[PRODUCT_QUERY_PARAMS.PAGE_SIZE] = `${FIRST_LOAD_PAGE_SIZE}`
    }

    if (!PUBLIC_IS_BOT) {
        requestParams.ut = ut
    }

    const { data, isFetching } = useQuery<GetProductListViewModelSuccessEnvelop>({
        queryKey: [PLPReactQueryKeys.PagesData, requestParams],
        queryFn: () => getProductsList(requestParams),
        refetchOnMount: false,
        staleTime: Infinity,
        placeholderData: keepPreviousData,
        enabled: !!searchParams,
    })

    const products = data?.data?.products?.items || []

    return {
        pageResponse: data?.data,
        products,
        isLoading: isFetching,
        searchParamsPageNumber,
        isLoadingFirstPage: isFetching && (!products || !products.length),
    }
}
